import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_UTILITY_REQUEST_PROJECTS,
  GET_UTILITY_REQUEST_PROJECTS_SUCCESS,
  GET_UTILITY_REQUEST_PROJECTS_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getUtilityRequestProjects() {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/projects`,
      method: 'GET',
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      yield put({
        type: GET_UTILITY_REQUEST_PROJECTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_UTILITY_REQUEST_PROJECTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_UTILITY_REQUEST_PROJECTS_ERROR, payload: error });
  }
}

export function* watchGetUtilityRequestProjects() {
  yield takeEvery(GET_UTILITY_REQUEST_PROJECTS, getUtilityRequestProjects);
}

function* getUtilityRequestProjectsSaga() {
  yield all([fork(watchGetUtilityRequestProjects)]);
}

export default getUtilityRequestProjectsSaga;
